import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

export default function BuildIcon({ ...props }) {
  return (
    <SvgIcon width="76" height="76" viewBox="0 0 76 76" {...props}>
      <path
        d="M70.4336 74.8868H5.56641C3.10695 74.8868 1.11328 72.8931 1.11328 70.4336V13.109H74.8867V70.4336C74.8867 72.8931 72.8931 74.8868 70.4336 74.8868Z"
        fill="#CBCBCB"
      />
      <path
        d="M70.3883 1.11328H5.61168C3.12728 1.11328 1.11328 3.12728 1.11328 5.61168V13.109H74.8867V5.61168C74.8867 3.12728 72.8727 1.11328 70.3883 1.11328Z"
        fill="#62D8F9"
      />
      <path
        d="M70.3883 13.109V70.3884C70.3883 72.8728 68.3743 74.8868 65.8899 74.8868H70.3883C72.8727 74.8868 74.8867 72.8728 74.8867 70.3884V13.109H70.3883Z"
        fill="#ABABAB"
      />
      <path
        d="M70.3883 1.11328H65.8899C68.3743 1.11328 70.3883 3.12728 70.3883 5.61168V13.109H74.8867V5.61168C74.8867 3.12728 72.8727 1.11328 70.3883 1.11328Z"
        fill="#00BEF7"
      />
      <path
        d="M10.4099 9.21049C11.5693 9.21049 12.5091 8.27065 12.5091 7.11129C12.5091 5.95193 11.5693 5.01208 10.4099 5.01208C9.25056 5.01208 8.31071 5.95193 8.31071 7.11129C8.31071 8.27065 9.25056 9.21049 10.4099 9.21049Z"
        fill="#FC8086"
      />
      <path
        d="M18.2072 9.21049C19.3665 9.21049 20.3064 8.27065 20.3064 7.11129C20.3064 5.95193 19.3665 5.01208 18.2072 5.01208C17.0478 5.01208 16.108 5.95193 16.108 7.11129C16.108 8.27065 17.0478 9.21049 18.2072 9.21049Z"
        fill="#FBE77B"
      />
      <path
        d="M26.0043 9.21049C27.1637 9.21049 28.1035 8.27065 28.1035 7.11129C28.1035 5.95193 27.1637 5.01208 26.0043 5.01208C24.845 5.01208 23.9051 5.95193 23.9051 7.11129C23.9051 8.27065 24.845 9.21049 26.0043 9.21049Z"
        fill="#B9EA6A"
      />
      <path d="M15.5081 24.355H60.492V31.8523H15.5081V24.355Z" fill="#818181" />
      <path
        d="M27.5038 51.4951H48.4963V58.9924H27.5038V51.4951Z"
        fill="#B9EA6A"
      />
      <path d="M15.5081 38H60.492V45.4973H15.5081V38Z" fill="#818181" />
      <path
        d="M49.2033 65.0241L53.4445 60.7829L39.8728 55.6936L44.9622 69.2652L49.2033 65.0241Z"
        fill="#F1FAFF"
      />
      <path
        d="M74.8867 23.6559C74.2717 23.6559 73.7734 24.1542 73.7734 24.7692V70.3883C73.7734 72.2549 72.2549 73.7734 70.3883 73.7734H5.61168C3.74508 73.7734 2.22656 72.2549 2.22656 70.3883V58.9402C2.22656 58.3252 1.72826 57.8269 1.11328 57.8269C0.498305 57.8269 0 58.3252 0 58.9402V70.3883C0 73.4826 2.51735 76 5.61168 76H70.3885C73.4827 76 76 73.4826 76 70.3883V24.7692C76 24.1543 75.5017 23.6559 74.8867 23.6559Z"
        fill="black"
      />
      <path
        d="M70.3883 0H5.61168C2.51735 0 0 2.51735 0 5.61168V53.7238C0 54.3388 0.498305 54.8371 1.11328 54.8371C1.72826 54.8371 2.22656 54.3388 2.22656 53.7238V14.2222H73.7734V19.5566C73.7734 20.1716 74.2717 20.6699 74.8867 20.6699C75.5017 20.6699 76 20.1716 76 19.5566V5.61168C76 2.51735 73.4827 0 70.3883 0V0ZM2.22656 11.9957V5.61168C2.22656 3.74508 3.74508 2.22656 5.61168 2.22656H70.3885C72.2549 2.22656 73.7734 3.74508 73.7734 5.61168V11.9958H2.22656V11.9957Z"
        fill="black"
      />
      <path
        d="M10.4099 3.8988C8.63846 3.8988 7.19743 5.33984 7.19743 7.11129C7.19743 8.88274 8.63846 10.3239 10.4099 10.3239C12.1814 10.3239 13.6226 8.88274 13.6226 7.11129C13.6226 5.33984 12.1812 3.8988 10.4099 3.8988ZM10.4099 8.09721C9.86634 8.09721 9.424 7.65501 9.424 7.11114C9.424 6.56756 9.86619 6.12522 10.4099 6.12522C10.9536 6.12522 11.396 6.56741 11.396 7.11114C11.3958 7.65487 10.9536 8.09721 10.4099 8.09721Z"
        fill="black"
      />
      <path
        d="M18.207 3.8988C16.4356 3.8988 14.9946 5.33984 14.9946 7.11129C14.9946 8.88274 16.4356 10.3239 18.207 10.3239C19.9785 10.3239 21.4197 8.88274 21.4197 7.11129C21.4197 5.33984 19.9785 3.8988 18.207 3.8988ZM18.207 8.09721C17.6635 8.09721 17.2211 7.65501 17.2211 7.11114C17.2211 6.56756 17.6633 6.12522 18.207 6.12522C18.7508 6.12522 19.1931 6.56741 19.1931 7.11114C19.1931 7.65487 18.7508 8.09721 18.207 8.09721Z"
        fill="black"
      />
      <path
        d="M26.0043 3.8988C24.2329 3.8988 22.7918 5.33984 22.7918 7.11129C22.7918 8.88274 24.2329 10.3239 26.0043 10.3239C27.7758 10.3239 29.217 8.88274 29.217 7.11129C29.217 5.33984 27.7756 3.8988 26.0043 3.8988ZM26.0043 8.09721C25.4607 8.09721 25.0184 7.65501 25.0184 7.11114C25.0184 6.56756 25.4606 6.12522 26.0043 6.12522C26.5481 6.12522 26.9904 6.56741 26.9904 7.11114C26.9902 7.65487 26.5481 8.09721 26.0043 8.09721Z"
        fill="black"
      />
      <path
        d="M15.5081 32.9655H60.492C61.1069 32.9655 61.6053 32.4672 61.6053 31.8523V24.355C61.6053 23.74 61.1069 23.2417 60.492 23.2417H15.5081C14.8932 23.2417 14.3949 23.74 14.3949 24.355V31.8523C14.3949 32.4672 14.8932 32.9655 15.5081 32.9655ZM16.6214 25.4683H59.3787V30.739H16.6214V25.4683Z"
        fill="black"
      />
      <path
        d="M48.4962 50.3818H27.5038C26.8889 50.3818 26.3905 50.8801 26.3905 51.4951V58.9924C26.3905 59.6074 26.8889 60.1057 27.5038 60.1057H40.3383L43.9197 69.6561C44.0527 70.0106 44.3564 70.2731 44.7264 70.3532C44.8047 70.3701 44.8838 70.3784 44.9622 70.3784C45.2543 70.3784 45.5384 70.2634 45.7495 70.0523L54.2316 61.5702C54.4994 61.3024 54.6127 60.9172 54.5325 60.5471C54.4524 60.1771 54.1898 59.8734 53.8355 59.7404L49.6094 58.1557V51.495C49.6094 50.8801 49.1111 50.3818 48.4962 50.3818ZM28.6171 57.8791V52.6084H47.3829V57.3208L40.2638 54.6512C39.8552 54.498 39.3944 54.5978 39.0855 54.9064C38.7769 55.2151 38.6772 55.6759 38.8304 56.0847L39.5034 57.8793H28.6171V57.8791ZM48.4162 64.2367C48.416 64.2367 48.416 64.2367 48.4162 64.2367L45.3975 67.2555L41.7754 57.596L51.4348 61.2182L48.4162 64.2367Z"
        fill="black"
      />
      <path
        d="M14.3949 45.4973C14.3949 46.1123 14.8932 46.6106 15.5081 46.6106H60.492C61.1069 46.6106 61.6053 46.1123 61.6053 45.4973V38C61.6053 37.385 61.1069 36.8867 60.492 36.8867H15.5081C14.8932 36.8867 14.3949 37.385 14.3949 38V45.4973ZM16.6214 39.1133H59.3787V44.384H16.6214V39.1133Z"
        fill="black"
      />
      <path
        d="M20.1565 26.6041C19.3283 26.6041 18.657 27.2755 18.657 28.1036C18.657 28.9318 19.3283 29.6032 20.1565 29.6032C20.9846 29.6032 21.656 28.9318 21.656 28.1036C21.6558 27.2754 20.9846 26.6041 20.1565 26.6041Z"
        fill="black"
      />
      <path
        d="M24.9547 26.6041C24.1266 26.6041 23.4552 27.2755 23.4552 28.1036C23.4552 28.9318 24.1266 29.6032 24.9547 29.6032C25.7828 29.6032 26.4542 28.9318 26.4542 28.1036C26.4542 27.2754 25.7828 26.6041 24.9547 26.6041Z"
        fill="black"
      />
      <path
        d="M29.753 26.6041C28.9248 26.6041 28.2535 27.2755 28.2535 28.1036C28.2535 28.9318 28.9248 29.6032 29.753 29.6032C30.5811 29.6032 31.2525 28.9318 31.2525 28.1036C31.2525 27.2754 30.5811 26.6041 29.753 26.6041Z"
        fill="black"
      />
      <path
        d="M34.5512 26.6041C33.7231 26.6041 33.0517 27.2755 33.0517 28.1036C33.0517 28.9318 33.7231 29.6032 34.5512 29.6032C35.3793 29.6032 36.0507 28.9318 36.0507 28.1036C36.0507 27.2754 35.3793 26.6041 34.5512 26.6041Z"
        fill="black"
      />
      <path
        d="M39.3496 26.6041C38.5215 26.6041 37.8501 27.2755 37.8501 28.1036C37.8501 28.9318 38.5215 29.6032 39.3496 29.6032C40.1778 29.6032 40.8491 28.9318 40.8491 28.1036C40.849 27.2754 40.1776 26.6041 39.3496 26.6041Z"
        fill="black"
      />
      <path
        d="M20.1565 40.249C19.3283 40.249 18.657 40.9204 18.657 41.7485C18.657 42.5767 19.3283 43.2481 20.1565 43.2481C20.9846 43.2481 21.656 42.5767 21.656 41.7485C21.6558 40.9204 20.9846 40.249 20.1565 40.249Z"
        fill="black"
      />
      <path
        d="M24.9547 40.249C24.1266 40.249 23.4552 40.9204 23.4552 41.7485C23.4552 42.5767 24.1266 43.2481 24.9547 43.2481C25.7828 43.2481 26.4542 42.5767 26.4542 41.7485C26.4542 40.9204 25.7828 40.249 24.9547 40.249Z"
        fill="black"
      />
      <path
        d="M29.753 40.249C28.9248 40.249 28.2535 40.9204 28.2535 41.7485C28.2535 42.5767 28.9248 43.2481 29.753 43.2481C30.5811 43.2481 31.2525 42.5767 31.2525 41.7485C31.2525 40.9204 30.5811 40.249 29.753 40.249Z"
        fill="black"
      />
      <path
        d="M34.5512 40.249C33.7231 40.249 33.0517 40.9204 33.0517 41.7485C33.0517 42.5767 33.7231 43.2481 34.5512 43.2481C35.3793 43.2481 36.0507 42.5767 36.0507 41.7485C36.0507 40.9204 35.3793 40.249 34.5512 40.249Z"
        fill="black"
      />
      <path
        d="M39.3496 40.249C38.5215 40.249 37.8501 40.9204 37.8501 41.7485C37.8501 42.5767 38.5215 43.2481 39.3496 43.2481C40.1778 43.2481 40.8491 42.5767 40.8491 41.7485C40.849 40.9204 40.1776 40.249 39.3496 40.249Z"
        fill="black"
      />
    </SvgIcon>
  );
}
